import * as jsxRuntime from "/home/ploi/app.timeero.com-deploy/app.timeero.com/18072025_072237/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment